import { render, staticRenderFns } from "./ac-sql-builder-comment-modal.vue?vue&type=template&id=33f49480&"
import script from "./ac-sql-builder-comment-modal.vue?vue&type=script&lang=js&"
export * from "./ac-sql-builder-comment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports